var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServicesConsulting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "486px",
    height: "486px",
    viewBox: "0 0 486 486",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "services-consulting") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "services-consulting",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-31",
    stroke: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 231,
    height: 154
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-31",
    fill: "#E680A8",
    opacity: 0.200000003,
    x: 97,
    y: 113,
    width: 17,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-32",
    fill: "#E680A8",
    opacity: 0.200000003,
    x: 118,
    y: 90,
    width: 17,
    height: 49
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-33",
    fill: "#E680A8",
    opacity: 0.200000003,
    x: 139,
    y: 105,
    width: 17,
    height: 34
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-34",
    fill: "#E680A8",
    opacity: 0.200000003,
    x: 160,
    y: 74,
    width: 17,
    height: 65
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-35",
    fill: "#E680A8",
    opacity: 0.200000003,
    x: 181,
    y: 63,
    width: 17,
    height: 76
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-36",
    fill: "#E680A8",
    opacity: 0.200000003,
    x: 202,
    y: 29,
    width: 17,
    height: 110
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.1848943,
    y1: 66,
    x2: 82.561594,
    y2: 66,
    id: "Path-12",
    stroke: "#FFFFFF",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.1848943,
    y1: 90,
    x2: 82.561594,
    y2: 90,
    id: "Path-12-Copy",
    stroke: "#FFFFFF",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.1848943,
    y1: 114,
    x2: 82.561594,
    y2: 114,
    id: "Path-12-Copy-2",
    stroke: "#FFFFFF",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.1848943,
    y1: 138,
    x2: 82.561594,
    y2: 138,
    id: "Path-12-Copy-3",
    stroke: "#FFFFFF",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "76%",
    transform: "translate(12.288, 96.032)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "6.352 1.12 6.352 0.144 0 0.144 0 1.264 5.056 1.264 1.584 9.968 2.848 9.968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.717,6.832 C8.717,5.504 9.597,4.592 10.845,4.592 C12.077,4.592 12.957,5.52 12.957,6.832 C12.957,8.128 12.077,9.04 10.845,9.04 C9.581,9.04 8.717,8.112 8.717,6.832 Z M13.981,2.432 C13.597,0.928 12.653,0 10.925,0 C8.797,0 7.325,2.048 7.325,5.232 C7.325,6.384 7.485,7.36 7.901,8.24 C8.509,9.472 9.549,10.112 10.829,10.112 C12.845,10.112 14.125,8.624 14.125,6.816 C14.125,5.04 12.845,3.552 10.941,3.552 C9.789,3.552 8.781,4.24 8.461,5.232 C8.461,5.136 8.445,4.896 8.445,4.8 C8.445,2.688 9.485,1.04 10.925,1.04 C11.917,1.04 12.461,1.6 12.733,2.432 L13.981,2.432 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.394,9.968 L17.386,9.968 L23.514,0.144 L22.522,0.144 L16.394,9.968 Z M16.282,2.128 C16.282,1.472 16.81,0.928 17.466,0.928 C18.122,0.928 18.666,1.472 18.666,2.128 C18.666,2.784 18.122,3.312 17.466,3.312 C16.81,3.312 16.282,2.784 16.282,2.128 Z M24.554,7.984 C24.554,6.8 23.61,5.856 22.426,5.856 C21.242,5.856 20.298,6.8 20.298,7.984 C20.298,9.168 21.242,10.112 22.426,10.112 C23.61,10.112 24.554,9.168 24.554,7.984 Z M19.594,2.128 C19.594,0.944 18.65,0 17.466,0 C16.282,0 15.338,0.944 15.338,2.128 C15.338,3.312 16.282,4.256 17.466,4.256 C18.65,4.256 19.594,3.312 19.594,2.128 Z M23.61,7.984 C23.61,8.64 23.082,9.184 22.426,9.184 C21.77,9.184 21.226,8.64 21.226,7.984 C21.226,7.328 21.77,6.8 22.426,6.8 C23.082,6.8 23.61,7.328 23.61,7.984 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E680A8",
    x: 11,
    y: 27,
    width: 30,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-38",
    fill: "#E680A8",
    opacity: 0.400000006,
    x: 11,
    y: 32,
    width: 56,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-39",
    fill: "#E680A8",
    opacity: 0.400000006,
    x: 11,
    y: 37,
    width: 63,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-37",
    fill: "#E680A8",
    opacity: 0.400000006,
    x: 11,
    y: 13,
    width: 76,
    height: 10,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-13",
    stroke: "#E680A8",
    points: "42.5 155 42.5 293.306025 87 293.306025"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E680A8",
    cx: 104,
    cy: 293,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    stroke: "#E680A8",
    cx: 159,
    cy: 293,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    stroke: "#E680A8",
    opacity: 0.5,
    cx: 214,
    cy: 293,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-6",
    stroke: "#E680A8",
    opacity: 0.5,
    cx: 269,
    cy: 293,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-7",
    stroke: "#E680A8",
    opacity: 0.5,
    cx: 324,
    cy: 293,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-8",
    stroke: "#E680A8",
    opacity: 0.5,
    cx: 379,
    cy: 293,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-8",
    stroke: "#E680A8",
    fill: "#E680A8",
    opacity: 0.5,
    cx: 379,
    cy: 293,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-9",
    stroke: "#E680A8",
    fill: "#E680A8",
    cx: 104,
    cy: 293,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-10",
    stroke: "#E680A8",
    fill: "#E680A8",
    cx: 159,
    cy: 293,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,293 L159,276.467494 C165.138126,276.842351 169.590921,279.109264 172.358386,283.268234 C176.509583,289.50669 175.251712,295.771603 175.247452,295.771603 C175.243192,295.771603 172.21511,303.536095 170.260365,305.068186 C168.305621,306.600277 167.716148,306.862838 167.689466,306.858517 C167.671678,306.855418 164.775189,302.235913 159,293 Z",
    id: "Path-14",
    fill: "#E680A8",
    opacity: 0.400000006
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.8,86.704 C246.8,86.096 246.512,85.712 246.112,85.472 C246.512,85.232 246.8,84.848 246.8,84.24 L246.8,33.28 C246.8,32.896 247.008,32.688 247.376,32.688 L249.056,32.688 L249.056,31.6 L247.392,31.6 C246.352,31.6 245.616,32.336 245.616,33.392 L245.616,84.32 C245.616,84.72 245.44,84.912 245.056,84.912 L244.32,84.912 L244.32,86.032 L245.056,86.032 C245.44,86.032 245.616,86.24 245.616,86.624 L245.616,137.552 C245.616,138.608 246.352,139.344 247.392,139.344 L249.056,139.344 L249.056,138.256 L247.376,138.256 C247.008,138.256 246.8,138.048 246.8,137.664 L246.8,86.704 Z",
    id: "Path",
    fill: "#E680A8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#E680A8",
    opacity: 0.400000006,
    x: 265.5,
    y: 38.5,
    width: 19,
    height: 19,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-42",
    stroke: "#E680A8",
    opacity: 0.400000006,
    x: 265.5,
    y: 74.5,
    width: 19,
    height: 19,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-40",
    stroke: "#E680A8",
    opacity: 0.400000006,
    x: 301.5,
    y: 38.5,
    width: 19,
    height: 19,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-43",
    stroke: "#E680A8",
    opacity: 0.400000006,
    x: 301.5,
    y: 74.5,
    width: 19,
    height: 19,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-41",
    stroke: "#E680A8",
    opacity: 0.400000006,
    x: 337.5,
    y: 38.5,
    width: 19,
    height: 19,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-44",
    stroke: "#E680A8",
    opacity: 0.400000006,
    x: 337.5,
    y: 74.5,
    width: 19,
    height: 19,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-47",
    stroke: "#E680A8",
    opacity: 0.400000006,
    x: 265.5,
    y: 110.5,
    width: 19,
    height: 19,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-46",
    stroke: "#E680A8",
    opacity: 0.400000006,
    x: 301.5,
    y: 110.5,
    width: 19,
    height: 19,
    rx: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesConsulting);
export default __webpack_public_path__ + "static/media/services-consulting.ba60eff4f2e3f6e8dd6139573c90e94f.svg";
export { ForwardRef as ReactComponent };